export const programmingSkills = [
  'Python',
  'C Language',
  'Dart',
  'Flutter',
  'JavaScript',
  'React',
  'HTML/CSS',
  'Tailwind',
  'Git',
]

export const softSkills = [
  'Leadership',
  'Communication',
  'Problem-Solving',
  'Teamwork',
  'Learning',
  'AI Interest',
]